import React from 'react'
import ForEach from './ForEach'
import CollectionEntryToModel from './CollectionEntryToModel'

function ForEachModel (props) {
  return (
    <ForEach>
      <CollectionEntryToModel>
        {props.children}
      </CollectionEntryToModel>
    </ForEach>
  )
}

export default ForEachModel
